// components.tabNavigation
const TAB_ATTRIBUTE = "data-tab";

function init() {
	const $navigation = document.querySelectorAll(".tab-navigation > span");

	$navigation.forEach(($item, i) => {
		$item.setAttribute(TAB_ATTRIBUTE, i + 1);
	});

	const $navigationMobile = document.querySelectorAll(".mobile-tab");

	$navigationMobile.forEach(($item, i) => {
		const $header = $item.querySelector(".mobile-tab-header");

		if ($header) {
			$header.setAttribute(TAB_ATTRIBUTE, i + 1);
		}

		const $content = $item.querySelector(".tab-content");

		if ($content) {
			$content.setAttribute(TAB_ATTRIBUTE, i + 1);
		}
	});
}

export { init };
